import React, { useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import ChangelogComponent from './ChangelogComponent';

function HomePage() {
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    const fetchLogoUrl = async () => {
      const storage = getStorage();
      const logoRef = ref(storage, 'logos/bethanylogo.png');
      try {
        const url = await getDownloadURL(logoRef);
        setLogoUrl(url);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };

    fetchLogoUrl();
  }, []);

  return (
    <div className="page-container">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          BETHANY SOLO MULTIMEDIA TEAM
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Welcome to the Multimedia Team Management App
        </p>
        <div className="flex justify-center mb-8">
          {logoUrl && (
            <img 
              src={logoUrl} 
              alt="Bethany Logo" 
              className="max-w-xs h-auto"
            />
          )}
        </div>
      </div>
      <div>
        <ChangelogComponent />
      </div>
    </div>
  );
}

export default HomePage;